/* eslint-disable */
const menuItems = [
  {
    grup: 'UTAMA',
    menu: [
      { img: '/home.png',              label: 'Dashboard',  id: 'dashboard' },
      { img: '/folder.png',           label: 'Master Data', id: 'master-data' },
      { img: '/project.png',           label: 'Proyek',     id: 'proyek'    },
      { img: '/schedule.png',          label: 'Jadwal',     id: 'jadwal'    },
    ]
  },
  {
    grup: 'OPERASIONAL',
    menu: [
      { img: '/shopping-cart.png',       label: 'Pengadaan',    id: 'pengadaan'     },
      { img: '/gudang.png',              label: 'Gudang',       id: 'gudang'        },
      { img: '/settings.png',            label: 'Peralatan',    id: 'peralatan'     },
    ]
  },
  {
    grup: 'KEUANGAN & SDM',
    menu: [
      { img: '/keuangan.png',          label: 'Keuangan',     id: 'keuangan' },
      { img: '/human-resources.png',   label: 'SDM & Payroll',id: 'sdm'      },
      { img: '/absensi.png',           label: 'Absensi',      id: 'absensi'  },
    ]
  },
  {
    grup: 'COMPLIANCE',
    menu: [
      { img: '/construction-safety.png', label: 'HSE / K3',   id: 'hse'   },
      { img: '/paper ISO.png',           label: 'Dokumen ISO', id: 'iso'   },
    ]
  },
  {
    grup: 'PENGATURAN',
    menu: [
      { img: '/user.png', label: 'Manajemen User', id: 'user-management' },
    ]
  },
];

function Sidebar({ menuAktif, onMenuKlik, user, onLogout, collapsed, onToggle }) {
  function buatInisial(nama) {
    const kata = nama ? nama.split(' ') : ['U'];
    return (kata.length >= 2
      ? kata[0][0] + kata[1][0]
      : kata[0].substring(0, 2)
    ).toUpperCase();
  }

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>

      <div className="sidebar-logo">
        <img src="/kop mkmj.jpg" alt="ERP MKMJ" className="sidebar-logo-img" />
        <span className="logo-text">ERP MKMJ</span>
        <button
          className="btn-toggle sidebar-toggle"
          onClick={onToggle}
          title={collapsed ? 'Tampilkan Sidebar' : 'Sembunyikan Sidebar'}
        >
          {collapsed ? '»' : '«'}
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems
          .filter(grup => grup.grup !== 'PENGATURAN' || user?.divisi === 'direktur')
          .map(function(grup) {
          return (
            <div className="nav-group" key={grup.grup}>
              <span className="nav-group-label">{grup.grup}</span>
              {grup.menu.map(function(item) {
                return (
                  <button
                    key={item.id}
                    className={`nav-item ${menuAktif === item.id ? 'active' : ''}`}
                    onClick={() => onMenuKlik(item.id)}
                  >
                    <span className="nav-icon">
                      {item.img
                        ? <img src={item.img} alt="" className="nav-icon-img" />
                        : item.icon}
                    </span>
                    <span className="nav-text">{item.label}</span>
                  </button>
                );
              })}
            </div>
          );
        })}
      </nav>

      <div className="sidebar-user">
        <div className="user-avatar">
          {buatInisial(user?.nama)}
        </div>
        <div className="user-info">
          <span className="user-name">{user?.nama}</span>
          <span className="user-role">{user?.role}</span>
        </div>
        <span
          className="user-logout"
          onClick={onLogout}
          title="Keluar"
        >
          <img src="logout.png" alt="Logout" width="40px" height="40px" />
        </span>
      </div>

    </aside>
  );
}

export default Sidebar;